export const LOCALES = {
    ENGLISH: "en-us",
    CHINESE: "ch-cn",
};